export const SET_QUESTION_NUMBER = 'SET_QUESTION_NUMBER';
export const CLEAR_QUESTION_NUMBER = 'CLEAR_QUESTION_NUMBER';
